<template>
  <v-col cols="12" :xl="chartWidth">
    <v-card flat elevation="5" height="100%">
      <!-- <v-select
        v-model="sources"
        v-if="getDataSources.length > 1"
        :items="getDataSources"
        :menu-props="{ origin: 'top center 0' }"
        class="source-input"
        hide-details
        dense
      ></v-select> -->
      <v-lazy
          v-model="lazyActive"
          min-height="300"
          :options="{
          threshold: 0.1,
        }"
          transition="fade-transition"
      >
        <!-- <Charts :option="customBaseChart" /> -->
        <v-card flat elevation="5" height="100%">
          <div class="d-flex justify-center">
            <span class="chart-title">客群趨勢圖</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" size="18"
                >mdi-help-circle-outline
                </v-icon
                >
              </template>
              <pre>{{ reportData.helpIcon.annotation }}</pre>
            </v-tooltip>
          </div>
          <v-tabs v-model="tab" grow>
            <v-tabs-slider></v-tabs-slider>

            <v-tab
                v-for="item in tabItem"
                :key="item.id"
                @click="scrollTo(`#customBase`)"
            >
              {{ item.name }}
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" size="20"
                  >mdi-help-circle-outline
                  </v-icon
                  >
                </template>
                <span>{{ item.helpIconMsg }}</span>
              </v-tooltip>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in tabItem" :key="item.id">
              <v-card flat min-height="400">
                <Charts :option="customBaseChart"/>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-lazy>
    </v-card>
  </v-col>
</template>

<script>
// import Charts from "@/components/Charts.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {boolean} from "joi";

export default {
  props: {
    chartInfoState: Boolean,
  },
  components: {
    // Charts,
    Charts: () => import("@/components/Charts.vue"),
  },
  watch: {
    tab: function () {

      this.tab
          ? this.setChartWithType("acc_") //180滾動
          : this.setChartWithType("");//當日
    },
    chartInfoState() {
      if (this.chartInfoState === true) {
        let chartInfo = {
          data: this.chartOption,
          id: "CustomerGroupTrend"
        };
        this.chartOption.title.text = this.tabItem[this.tab].name;
        this.chartOption.subtitle.text = this.clickdate;
        this.$emit("addChartInfo", chartInfo);
      }

    }
  }
  ,
  computed: {
    ...mapGetters("customanalysis", [
      "getDateRange",
      "getCustomerBaseReport",
      "getDataSources",
    ]),
    chartWidth() {
      //資料範圍 15 天以上 col=12
      const {series = []} = this.getCustomerBaseReport || [];
      const dataRange = this.getDateRange;
      return series.length > 0 && dataRange.length > 15 ? "12" : "6";
    },
    customBaseChart() {
      //總客群圖
      const option = this.reportData;

      //  this.tab
      //     ? this.setChartWithType("acc_") //180滾動
      //     : this.setChartWithType("");//當日


      const report = this.getCustomerBaseReport; //vuex

      // const sources = this.getDataSources; //vuex
      option.xAxis.categories = this.getDateRange; //vuex
      option.series = report.series;
      // option.subtitle.text = sources.length < 2 ? report.source : "";
      this.clickdate = "";
      option.plotOptions.series.point.events = {
        click: ({point}) => {
          const {
            category,
            series: {
              userOptions: {name},
            },
          } = point;
          this.clickdate = category
          const dateIndex = this.getDateRange.indexOf(category);
          this.updateCustomerReport({dateIndex: dateIndex, groupName: name});
          this.scrollTo(`#Customer`);
        },
      };
      this.chartOption = option;
      return option;
    },
  },
  methods: {
    ...mapMutations("customanalysis", ["setCustomerBaseReport", "setCountType"]),
    ...mapActions("customanalysis", ["updateCustomerReport", "setChartWithType"]),
    scrollTo(target) {
      this.$emit("goto", target);
    },
  },
  data: () => ({
    chartOption: {},
    lazyActive: false,
    tab: null,
    clickdate: "",
    tabItem: [
      {
        id: 1,
        name: "當日客群",
        helpIconMsg: "當日進站人群的客群分布趨勢",
      },
      {
        id: 2,
        name: "180日客群",
        helpIconMsg: "180日內進站人群的客群分布趨勢",
      },
    ],
    reportData: {
      chart: {
        zoomType: "x",
        resetZoomButton: {
          relativeTo: "chart",
        },
      },
      title: {
        text: "",
        margin: 50,
      },
      subtitle: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        labels: {
          formatter() {
            return this.value ? this.value.substring(5) : "0";
          },
        },
        categories: [],
      },
      yAxis: {
        title: {
          text: "",
        },
        plotLines: [
          {
            value: 0,
            width: 1,
            color: "#808080",
          },
        ],
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        borderWidth: 0,
      },
      series: [],
      plotOptions: {
        series: {
          cursor: "pointer",
          point: {},
          marker: {enabled: false},
          animation: {
            duration: 300,
          },
        },
      },
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
      },
      helpIcon: {
        annotation: `新訪客   : 第一次到站且在近30天內
活躍客群 : 近30天內到站次數超過一次
潛在客群 : 近30~60天到站次數大於一次，且近30天內到站次數不超過一次
回流訪客 : 上一次進站時間為60天前，且於60天內有一次進站紀錄`, //pre排版，亂動會跑版
        enabled: false,
      },
    },
  }),
};
</script>
<style lang="css">
.chart-title {
  font-size: 18px;
  margin-top: 5px;
}

.source-input .v-select__selections {
  min-width: 200px;
}

.source-input .v-select__selection {
  max-width: 100%;
  padding: 0 20px;
}

.source-input .v-input__slot:before,
.source-input .v-input__slot:after {
  content: none !important;
}

.source-input .v-select__selection--comma {
  margin: 0 auto !important;
}

.source-input .v-input__append-inner,
.source-input .v-select__selections > input {
  display: none !important;
}

.source-input {
  position: absolute;
  z-index: 4;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -10%);
  font-size: 0.8rem;
  font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica,
  sans-serif;
}
</style>
